import constants from '../../containers/function/constants';

const initialState = {
  datos: [],
  loading: true,
  status: null,
  loadingTableSpiner: false,
  count: {},
  statusCount: null,
  filters: {
    periodReport: constants.periodReportTypes.lastDataReport,
    date: {
      fechaStartFinal: null,
      fechaEndFinal: null
    },
    tags: [],
    workingShiftGroup: null,
    driver: null
  },
  active:false
};

export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/last_data_ffd_pvt/initialState.js